export default {
  nav: {
    today: 'Heute',
    activities: 'Aktivitäten',
    analysis: 'Analyse',
    health: 'Health',
    goals: 'Ziele & Rekorde',
    planning: 'Planung',
    season: 'Saison',
    maps: 'Karten',
    gear: 'Ausrüstung',
    wrapped: 'Wrapped',
    settings: 'Einstellungen',
  },
  tab: { goals: 'Ziele', more: 'Mehr' },
  mainNav: 'Hauptnavigation',
  account: 'Konto',
  lastSynced: 'Zuletzt synchronisiert',
  syncRunning: 'Läuft …',
  syncNow: 'Jetzt synchronisieren',
  syncNever: 'noch nie',
  syncFailed: 'fehlgeschlagen {ago}',
  authOidc: 'über Login-Dienst',
  authProxy: 'über Proxy',
  authDev: 'lokal, ohne Anmeldung',
  pageLoading: 'Seite lädt …',
  notFound: 'Seite nicht gefunden',
  notFoundText: 'Diese Adresse gibt es in dashy-dash nicht – vielleicht ein alter Link.',
  notFoundBack: 'Zu Heute',
};
